import { useEffect, useState } from 'react';
import { client } from '../libs/client';
import { Link } from 'react-router-dom';

function Column() {
  const [articles, setArticles] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const getArticleImage = (article) =>
    article.eyecatch?.url ||
    article.thumbnail?.url ||
    article.image?.url ||
    article.mainImage?.url;

  useEffect(() => {
    client
      .get({
        endpoint: 'columns',
      })
      .then((res) => {
        setArticles(res.contents);
        setIsLoaded(true);
      })
      .catch(() => {
        setArticles([]);
        setIsLoaded(true);
      });
  }, []);

  const columnGridClass = `column-grid column-grid--count-${Math.min(articles.length, 3)}`;

  return (
    <section className="section column-section" id="column">
      <div className="container">
        <div className="section-head reveal">
          <p className="section-label">COLUMN</p>
          <h2 className="section-title">コラム</h2>
          <p className="section-desc">記事一覧</p>
        </div>

        {!isLoaded ? null : articles.length === 0 ? (
          <p className="column-empty">現在、コラム記事を準備中です。</p>
        ) : (
          <div className={columnGridClass}>
            {articles.map((article) => (
              <article className="column-card" key={article.id}>
                {getArticleImage(article) && (
                  <Link to={`/column/${article.id}`} className="column-image">
                    <img src={getArticleImage(article)} alt="" />
                  </Link>
                )}

                <p className="column-date">
                  {new Date(article.date).toLocaleDateString('ja-JP')}
                </p>

                <h3 className="column-title">
                  {article.title}
                </h3>

                <p className="column-text">
                  {article.excerpt}
                </p>

                <Link
                  to={`/column/${article.id}`}
                  className="column-link"
                >
                  READ MORE
                </Link>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default Column;
